import { useEffect, useRef, useState, useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { sleep } from '../../utils/index';
import MediaService from '../../services/MediaService';
import './WorldActions.scss';
import { Zoom } from '@mui/material';

const WorldActions = ({
  showLearn,
  showPractice,
  showCelebrate,
  showPhotoTime,
  showReview,
  showReward,
  showSingingTime,
  showClosingVideo,
  onLearnClick,
  onPracticeClick,
  onCelebrateClick,
  onPhotoTimeClick,
  onSingingTimeClick,
  onRewardClick,
  moduleDay,
}) => {
  const { module1 } = useSelector((state) => state.module1, shallowEqual)
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [reviewActive, setReviewActive] = useState(false);
  const [reviewActive4, setReviewActive4] = useState(false);

  const [touchButton, setTouchButton] = useState(false);

  const actionsRef = useRef();

  const learnBtnIcon = MediaService.getImage(
    '/Module1Images/Button_Learn.png',
    login
  );

  const practiceBtnIcon = MediaService.getImage(
    '/Module1Images/Button_Practice.png',
    login
  );

  const celebrateBtnIcon = MediaService.getImage(
    '/Module1Images/Button_Celebrate.png',
    login
  );

  const reviewBtnIcon = MediaService.getImage(
    '/Module1Images/Button_Review.png',
    login
  );

  const rewardBtnIcon = MediaService.getImage(
    '/Module1Images/Button_Reward_3x.png',
    login
  );

  const photoTimeBtnIcon = MediaService.getImage(
    '/Module1Images/Button_PhotoTime.png',
    login
  );

  const singingTimeBtnIcon = MediaService.getImage(
    '/Module1Images/Button_SingingTime.png',
    login
  );

  const bouncingSound = MediaService.getVideo(
    '/Module1Videos/button_bouncing.mp3',
    login
  );

  const touchSound = MediaService.getVideo(
    '/Module1Videos/touch_button.mp3',
    login
  );

  const handleButtonClick = async (type) => {
    setTouchButton(true);
    await sleep(700);
    switch (type) {
      case 'learn':
        onLearnClick();
        break;
      case 'practice':
        onPracticeClick(true);
        break;
      case 'celebrate':
        onCelebrateClick();
        break;
      case 'photoTime':
        onPhotoTimeClick();
        break;
      case 'singingTime':
        onSingingTimeClick();
        break;
      case 'review':
        actionsRef.current.style.display = 'none';
        moduleDay === 4 ? setReviewActive4(true) : setReviewActive(true);
        break;
      case 'reward':
        actionsRef.current.style.display = 'none';
        onRewardClick();
        break;
      default:
        break;
    }
  };

  const getGridColumns = async () => {
    const children = [...actionsRef.current.children];
    const cols = children.filter((el) => el.nodeName === 'BUTTON').length;
    actionsRef.current.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;
    actionsRef.current.style.display = 'grid';
  };

  const playBounceAudio = (async () => {
    const bounceAudio = new Audio(bouncingSound);

    // Don't play sound if showing day 9 ending video
    if (showClosingVideo) {
      return;
    }

    // Don't play sound if showing day 4 intro video
    if (showPhotoTime) {
      return;
    }

    // Don't play sound if showing day 5 intro video
    if (moduleDay === 5 && showLearn) {
      return;
    }

    if (
      showLearn ||
      showPractice ||
      showReview ||
      showSingingTime ||
      showCelebrate
    ) {
      await sleep(500);
      bounceAudio.play();
    }
  });

  useEffect(() => {
    playBounceAudio();
  }, [showLearn,showPractice,showReview, showSingingTime, showCelebrate]);

  useEffect(() => {
    getGridColumns();
  }, [reviewActive, reviewActive4]);

  return (
    <div className='action-buttons' ref={actionsRef}>
      {touchButton && (
        <audio autoPlay onEnded={() => setTouchButton(false)}>
          <source src={touchSound} type='audio/mp3' />
        </audio>
      )}

      {((showLearn && !showReview) || reviewActive) && (
        <button
          onClick={() => handleButtonClick('learn')}
          className={`${!reviewActive && 'bounce'}`}
        >
          <img src={learnBtnIcon} alt='learn button' />
        </button>
      )}

      {((showPractice && !showReview) || reviewActive) && (
        <button
          onClick={() => handleButtonClick('practice')}
          className={`${!reviewActive && 'bounce'}`}
        >
          <img src={practiceBtnIcon} alt='practice button' />
        </button>
      )}

      {((showCelebrate && !showReview) || reviewActive) && (
        <button
          onClick={() => handleButtonClick('celebrate')}
          className={`${!reviewActive && 'bounce'}`}
        >
          <img src={celebrateBtnIcon} alt='celebrate button' />
        </button>
      )}

      {((showPhotoTime && !showReview) || reviewActive4) && (
        <button
          onClick={() => handleButtonClick('photoTime')}
          className='bounce'
        >
          <img src={photoTimeBtnIcon} alt='phototime button' />
        </button>
      )}

      {((showSingingTime && !showReview) || reviewActive4) && (
        <button
          onClick={() => handleButtonClick('singingTime')}
          className='bounce'
        >
          <img src={singingTimeBtnIcon} alt='singing time button' />
        </button>
      )}

      {showReview && !reviewActive && !reviewActive4 && (
        <button onClick={() => handleButtonClick('review')} className='bounce'>
          <img src={reviewBtnIcon} alt='review button' />
        </button>
      )}
      {showReward && !reviewActive && !reviewActive4 && (
        <button onClick={() => handleButtonClick('reward')} className='bounce'>
          <img src={rewardBtnIcon} alt='reward button' style={{ zoom: '150%' }} />
        </button>
      )}
    </div>
  );
};

export default WorldActions;
